import { Injectable } from '@angular/core';
import { HttpClient,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';
import { IPagedResults } from '../../../services/mocks/mock.interfaces';
import { User } from '../../../models/user.model';
import { LoggerService } from '../../../shared/services/logger.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminDashService {

  constructor(private http: HttpClient,
              private logger: LoggerService) {
  }

  getUserProfile(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/profile/username');
  }
  saveUserData(user: User): Observable<any> {  
    console.log('---------------calling userdata/save----')
    return this.http.post<any>(environment.apiBase+'/userdata/save',user);
  }
  getUserData(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/userdata');
  }
}
